import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["unassignedListingsNotificationModal"]
  static values = {
    unassignedListingsCount: Number
  }

  connect() {
    if(this.unassignedListingsCountValue > 0 && sessionStorage.getItem("notification_already_shown") == undefined) {
      $(this.unassignedListingsNotificationModalTarget).modal("show")
      sessionStorage.setItem("notification_already_shown", true)
    }
  }
}
